const hostname = window.location.hostname;
const isDev =
  hostname === 'localhost' ||
  hostname.startsWith('192.168') ||
  hostname.startsWith('127.0.0.1');
export const baseOrigin = `https://local.biovisart.com/api`;
export const baseOrigin2 = `https://local2.biovisart.com/api`;
export const customBaseURL = `https://api.sangerbox.com/api`;
export const biovisartWebSocket = `wss://local.biovisart.com/ws/biovisart`;
// export const imgBaseOrigin = `https://api.sangerbox.com/static/gallery`;
export const imgBaseOrigin = `https://fss.sangerbox.com/biovistart/gallery`;
export const baseDrawioUrl = isDev
  ? "http://192.168.31.212:5050"
  : "https://draw.biovisart.com";